var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('div',{staticClass:"vue-audio"},[_c('audio-aplayer',{attrs:{"mutex":"","autoplay":"","theme":"#41466E","music":_vm.misicData}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }